
import { HttpResponse, defaultHttpResponse } from "../auth/AuthInterface";

import { PaginacionProps } from "../global/PaginacionInterface";

import { defaultExpediente, ExpedienteProps } from "../recepcion/ExpedienteInterface";

// Definición de defaults

export const defaultCertificacion: CertificacionProps = {
    idCertificacion:            0,
    idPlantilla:                0,
    contenido:                  '',
    documento:                  '',   
    idEstatus:                  0,
    usuarioActualAsignacion:    false,
    usuarioAsignacion:          '',  
    expediente:                 defaultExpediente,
}

export const defaultDetalleCertificacion: DetalleCertificacionResponse = {
    ...defaultHttpResponse,
    ...defaultCertificacion,
}

export const defaultNuevaCertificacion: NuevaCertificacionResponse = {
    ...defaultHttpResponse,
    idCertificacion:    '',
}

export const defaultActualizarEstatus: ActualizarEstatusResponse = {
    ...defaultHttpResponse,
    usuarioAsignado:        '',
    asignadoMismoUsuario:   false,
}

export const defaultConsultaCertificaciones: ConsultaCertificacionesResponse = {
    recordsCount:       0,
    currentPageIndex:   0,
    pageCount:          0,
    records:            [],
}

// Creación de interfaces

export interface NuevaCertificacionParams{
    idExpediente:       number;
}

export interface NuevaCertificacionResponse extends HttpResponse {
    idCertificacion:    string;
}

export interface GuardarCertificacionParams{
    idCertificacion:    string;
    idPlantilla:        number;
    contenido:          string;
}

export interface CertificacionProps{
    idCertificacion:            number;
    idPlantilla:                number;
    contenido:                  string;
    documento:                  string;   
    idEstatus:                  number;
    usuarioActualAsignacion:    boolean;
    usuarioAsignacion:          string;  
    expediente:                 ExpedienteProps;
    fecha?:                     Date;   
}

export interface DetalleCertificacionResponse extends HttpResponse, CertificacionProps {}

export interface ActualizarEstatusParams{
    idCertificacion:    string;
    idEstatus:          number;
}

export interface ActualizarEstatusResponse extends HttpResponse {
    usuarioAsignado:            string;
    asignadoMismoUsuario:       boolean;
}

export interface ConsultarCertificacionesParams extends PaginacionProps {
    idAutoridad:            number;
    idMateria:              number;
    idUsuarioElaboro:       number;
    idUsuarioAsignacion:    number;
    numeroExpediente:       string;
}

export interface ConsultarCertificacionesProps {
    idCertificacion:        number;
    numeroSeguimiento:      string;
    documentoCertificacion: string;
    idExpediente:           number;
    numeroExpediente:       string;
    idEstatus:              number;
    estatus:                string;
    usuarioCertifico:       string;
    usuarioAsignado:        string;
    expediente:             ExpedienteProps;
    fechaCertificacion?:    Date;
}

export interface ConsultaCertificacionesResponse {
    recordsCount:       number;
    currentPageIndex:   number;
    pageCount:          number;
    records:            ConsultarCertificacionesProps[];
}

export interface DescargarCertificacionesParams {
    idAutoridad:            number;
    idMateria:              number;
    idUsuarioElaboro:       number;
    idUsuarioAsignacion:    number;
    numeroExpediente:       string;
}